import { ChangeDetectorRef, Component, ElementRef, forwardRef, Inject, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { IntegrationCompany, LicensePackageOptions, LicensePackageType, LicenseStatus } from "sharedGuiSmall/enums";
import { AuthAppService } from "sign-up-app/services/auth.service";
import { NewPlanForm, NewPlanFormBodyComponent } from "sharedFeatures/sharedGui/components/newplan-win";
import { AuthData } from "sharedFeatures/sharedModels";
import { AppComponent } from "../root";
import { AuthUtils, Utils } from "sharedFeatures/utils";

@Component({
    selector: 'brixx-start',
    templateUrl: './brixx-start.component.html',
    styleUrls: ['./brixx-start.component.less']
})
export class BrixxStartBodyComponent implements OnInit{

    packageType: string | undefined = '';
    licenseType: string = LicensePackageType.BrixxFree;
    stepNumber: number = 3;
    returnLinkForm: string = 'sign-up/foundation';

    authData?: AuthData;

    dialogCreator!: AppComponent

    @ViewChild('newplanForm')
    newPlanForm!: NewPlanForm;

    @ViewChild('renderDiv')
    renderDiv!: ElementRef<HTMLElement>;

    loadAuthDataPromise?: Promise<void>;

    loadAuthData = (async () => {

        let tempAuthData = await this.authService.getAuthData();
        if (tempAuthData.priceOptionCodes.length === 0) {
            await this.createOrganisation(tempAuthData.userID, tempAuthData.email, this.packageType!);
            tempAuthData = await this.authService.getAuthData();
        }
       
        this.authData = tempAuthData;
        this.licenseType = AuthUtils.getLicensePackageType(this.authData.priceOptionCodes);
        
        if (this.licenseType === "" || this.licenseType === undefined) {
            this.router.navigate([this.returnLinkForm], { skipLocationChange: false });
        }
        
        this.chDet.detectChanges();
    });

    constructor(private authService: AuthAppService, private router: Router, @Inject(forwardRef(() => AppComponent)) parent: AppComponent, private r: Renderer2, private chDet: ChangeDetectorRef) {
        this.dialogCreator = parent;
        this.getPackageType();
    }

    ngOnInit() {
        if (!this.authService.isSpinnerHidden) {
            this.authService.toggleSpinner();
        }
    }
    
    ngAfterViewInit() {
        let refreshBillingState = Utils.getQueryParam(document.location.href, 'refreshBillingState');
        let refNo = Utils.getQueryParam(document.location.href, 'refNo');

        if (refreshBillingState && refNo) {            
            // create temporary license for user
            if (this.packageType)
                this.authService.CreateTemporaryLicense(this.convertPackageName(this.packageType), refNo).then(_ => {
                    this.onLoadAuthData();
                })
        }
        else
            this.onLoadAuthData();        
    }

    onLoadAuthData(): void { 
        this.loadAuthDataPromise = this.loadAuthData();

        if (this.loadAuthDataPromise) {
            this.loadAuthDataPromise.then(_ => {
                this.onAfterLoadAuthData();
            });
        }
    }

    onAfterLoadAuthData(): void { 
        this.r.setStyle(this.newPlanForm.getElDom(), 'position', 'relative');
        this.newPlanForm.setSize(this.renderDiv.nativeElement.offsetWidth, 0);
        this.r.setStyle(this.newPlanForm.getElDom(), 'height', 'auto')
        this.newPlanForm.renderForSignup = true;

        this.newPlanForm.setTransparentPopupStyle();

        let body = <NewPlanFormBodyComponent>this.newPlanForm.getBodyComponent();
        body.setXeroImportModeEnabled(false);
        body.setConnectedToXero();

        body.getActiveForm().ngOnChanges();

        this.newPlanForm.show(0, 0);
        this.newPlanForm.setTopest(true);                
        
        if (this.packageType !== undefined) {
            switch (this.licenseType) {
                case LicenseStatus.Trial:
                case LicensePackageType.BrixxFree:
                    this.stepNumber = 3;
                    break;
                case LicensePackageType.BrixxSingle:
                    this.stepNumber = 4;
                    break;
            }
        }
    }

    getPackageType() {        
        this.packageType = localStorage.getItem('packageTypeRegistration') ?? '';
    }

    convertPackageName(packageId: string) {
        switch (packageId) {
            case "Essentials": return "Startup";
            case "Professional": return "Business";
            case "Enterprise": return "Professional";
            default: return "none";
        }
    }

    async createOrganisation(customerId: number, newUserEmail: string, packageType: string): Promise<any> {
        const res: string = await this.authService.SetupOrganisation(customerId, newUserEmail, packageType, false);
        let data = { success: false, companyId: '' };
        if (res && res.length && res.indexOf("error=sessiontimeout") === -1) {
            data = JSON.parse(res);
            if (data.success) {
                if (!Utils.isNumeric(data.companyId)) 
                    throw new Error(`brixx-start.body.createOrganisation: selectedCompanyId:${data.companyId} is not numeric`);
                
                localStorage.setItem('selectedCompanyId', data.companyId);
            }
            localStorage.setItem('isCrunchFlow', (IntegrationCompany[window.integrationCompanyName] == IntegrationCompany.Crunch) + '');
        }
    }

}